import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { NoValue } from '~/modules/common/components';
import { useIsBreakpointDown } from '~/modules/common/hooks';

const labelIds = {
  address: 'projectBasicInfoCard.addressInfo.fields.address',
  city: 'projectBasicInfoCard.addressInfo.fields.city',
  stateProvince: 'projectBasicInfoCard.addressInfo.fields.stateProvince',
  zipPostalCode: 'projectBasicInfoCard.addressInfo.fields.zipPostalCode',
  country: 'projectBasicInfoCard.addressInfo.fields.country',
  addressType: 'projectBasicInfoCard.addressInfo.fields.addressType'
};

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.text.primary
    }
  },
  text: {
    textWrap: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    '&:focus': {
      outline: 'none',
      backgroundColor: theme.palette.grey[200]
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.75),
      color: theme.palette.text.primary
    }
  },
  label: {
    color: theme.palette.text.secondary
  }
}));

const AddressFieldReadOnly = ({ record, field, children }) => {
  const isMobile = useIsBreakpointDown('sm');
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const value = record[field]?.displayText || record[field];

  return (
    <>
      {isMobile && (
        <Typography variant="caption" className={classes.label}>
          {formatMessage({ id: labelIds[field] })}
        </Typography>
      )}
      <Typography variant="body2" tabIndex={0} className={classes.text}>
        {children || value || <NoValue classes={classes} />}
      </Typography>
    </>
  );
};

AddressFieldReadOnly.propTypes = {
  record: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default AddressFieldReadOnly;
